import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import ErrorBoundary from './components/ErrorBoundary';
import { PageLoading } from './components/ui/loading';

// Lazy load all page components for better performance
const Home = React.lazy(() => import('./pages/Home'));
const About = React.lazy(() => import('./pages/About'));
const Services = React.lazy(() => import('./pages/Services'));
const Contact = React.lazy(() => import('./pages/Contact'));
const CompliancePage = React.lazy(() => import('./pages/CompliancePage'));
const CloudSecurityPage = React.lazy(() => import('./pages/CloudSecurityPage'));
const AIImplementationPage = React.lazy(() => import('./pages/AIImplementationPage'));
const HealthcarePage = React.lazy(() => import('./pages/industries/HealthcarePage'));
const LegalPage = React.lazy(() => import('./pages/industries/LegalPage'));
const ManufacturingPage = React.lazy(() => import('./pages/industries/ManufacturingPage'));
const AICaseStudiesPage = React.lazy(() => import('./pages/resources/AICaseStudiesPage'));
const AIToolsPage = React.lazy(() => import('./pages/resources/AIToolsPage'));
const AIGuidesPage = React.lazy(() => import('./pages/resources/AIGuidesPage'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const HeroDemo = React.lazy(() => import('./pages/HeroDemo'));

const App: React.FC = () => {
  return (
    <ErrorBoundary level="page">
      <Router>
        <Suspense fallback={<PageLoading text="Loading page..." />}>
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="services" element={<Services />} />
              <Route path="services/compliance" element={<CompliancePage />} />
              <Route path="services/cloud-security" element={<CloudSecurityPage />} />
              <Route path="services/ai-implementation" element={<AIImplementationPage />} />
              <Route path="industries/healthcare" element={<HealthcarePage />} />
              <Route path="industries/legal" element={<LegalPage />} />
              <Route path="industries/manufacturing" element={<ManufacturingPage />} />
              <Route path="resources/ai-case-studies" element={<AICaseStudiesPage />} />
              <Route path="resources/ai-tools" element={<AIToolsPage />} />
              <Route path="resources/ai-guides" element={<AIGuidesPage />} />
              <Route path="contact" element={<Contact />} />
              <Route path="hero-demo" element={<HeroDemo />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
